import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AvatarModule } from 'primeng/avatar';
import { DialogComponent } from '../../../../../@core/components/ui/dialog/dialog.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { ButtonComponent } from '../../../../../@core/components/ui/button/button.component';
import { SelectComponent, SelectOption, SelectConfig } from '../../../../../@core/components/ui/select';
import { USER_TYPE } from '../../../../../@core/models/enums';
import { IShareUser, IUser, SHARE_ACCESS, SHARE_FEATURE } from '../../../../../@core/models/model';
import { AuthenticationService } from '../../../../../@core/services/authentication.service';
import { ToastService } from '../../../../../@core/services/toast.service';
import { ShareContractService } from '../../../../../contract-management/services/share-contract.service';
import { ShareService } from '../../../../../contract-management/services/share.service';
import { FullNamePipe } from '../../../../pipes/fullName.pipe';
import { UserAvatarPipe } from '../../../../pipes/user-avatar-pipe';

@Component({
  selector: 'app-share-access-dialog',
  standalone: true,
  imports: [
    DialogComponent,
    RadioButtonModule,
    SelectModule,
    ButtonComponent,
    CommonModule,
    FormsModule,
    UserAvatarPipe,
    AvatarModule,
    FullNamePipe,
    SelectComponent
  ],
  templateUrl: './share-access-dialog.component.html',
  styleUrl: './share-access-dialog.component.scss'
})
export class ShareAccessDialogComponent {

  @Input() user: Partial<IUser> = {}
  @Input() users: Partial<IUser>[] = []

  @Input() visible: boolean = false

  @Input() orgLevel: boolean = false
  @Input() workspaceLevel: boolean = false

  @Input() selectedAccessOption: string = 'shareWithPeople'
  @Input() selectedPermission: SHARE_ACCESS = SHARE_ACCESS.VIEW

  @Input() resource: string = ''
  @Input() feature: SHARE_FEATURE = SHARE_FEATURE.CONTRACT

  @Input() permissions: SHARE_ACCESS[] = [SHARE_ACCESS.VIEW, SHARE_ACCESS.EDIT, SHARE_ACCESS.COMMENT]

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>()

  @Output() userAccessChanged: EventEmitter<{ user: Partial<IUser>, shareUser: Partial<IShareUser>, hasAccess: boolean }> = new EventEmitter<{ user: Partial<IUser>, shareUser: Partial<IShareUser>, hasAccess: boolean }>()

  permissionOptions: SelectOption[] = [
    { label: 'Commenter', value: 'Comment' },
    { label: 'Editor', value: 'Edit' },
    { label: 'Viewer', value: 'View' },
  ];

  permissionConfig: SelectConfig = {
    placeholder: 'Select permission',
    searchable: false,
    clearable: false,
    styleClass: 'border',
    appendTo: 'body'
  };

  currentUser: Partial<IUser> | null = null

  noAccessToShare: boolean = false



  constructor(
    private shareService: ShareService,
    private authService: AuthenticationService,
    private toast: ToastService,
    private shareUser: ShareContractService
  ) {
    this.authService.currentUser.subscribe(res => {
      this.currentUser = res ?? null
    })
  }

  ngOnInit() {
    if (this.currentUser && this.orgLevel) {
      if (this.currentUser.workspaceRole == SHARE_ACCESS.ADMIN || this.currentUser.workspaceRole == SHARE_ACCESS.OWNER) {
        this.selectedAccessOption = 'shareWithPeople'
      } else {
        this.noAccessToShare = true
      }
    }

    this.permissionOptions = this.permissionOptions.filter(permission => this.permissions.includes(permission.value as SHARE_ACCESS))
    this.selectedPermission = this.permissionOptions[0].value as SHARE_ACCESS
  }

  giveAccessToShareUser() {
    if (this.feature === SHARE_FEATURE.PROJECT) {
      this.userAccessChanged.emit({
        user: this.user, shareUser: {
          email: this.user.email,
          role: this.selectedPermission,
          name: this.user.fullName,
          user: this.user._id,
          type: USER_TYPE.INTERNAL,
        }, hasAccess: false
      })
      this.closeDialog()
      return;
    }
    if (this.feature === SHARE_FEATURE.GENERAL_AGENT) {
      this.selectedPermission = SHARE_ACCESS.VIEW;
    }
    this.shareService.giveAccessToShareUser({
      name: this.user?.fullName ?? (this.user?.firstName + ' ' + this.user?.lastName),
      user: this.user._id,
      email: this.user.email ?? '',
      type: USER_TYPE.INTERNAL as any,
      role: this.selectedPermission,
    }, this.resource, this.feature).subscribe(res => {
      if (res.data.hasAccess) {
        this.toast.success('User added to workspace successfully')
        this.closeDialog()
        this.userAccessChanged.emit({
          user: this.user, shareUser: {
            email: this.user.email,
            role: this.selectedPermission,
            name: this.user.fullName,
            user: this.user._id,
            type: USER_TYPE.INTERNAL,
          }, hasAccess: res.data.hasAccess
        })
      }
    })
  }

  closeDialog() {
    this.visible = false
    this.visibleChange.emit(false)
  }

  visibleChangeEvent() {
    this.visibleChange.emit(this.visible)
  }

  onAccessOptionChange(option: string) {
    this.selectedAccessOption = option;
  }
  addToShareUser(event: Event) {
    event.stopPropagation();
    this.shareUser.addUserToShare(this.resource, {
      email: this.user.email,
      role: this.selectedPermission,
      name: this.user.fullName,
      user: this.user._id,
      type: USER_TYPE.INTERNAL,
    }, SHARE_FEATURE.CONTRACT).subscribe((res) => {
      if (res.success) {
        this.userAccessChanged.emit({
          user: this.user, shareUser: {
            email: this.user.email,
            role: this.selectedPermission,
            name: this.user.fullName,
            user: this.user._id,
            type: USER_TYPE.INTERNAL,
          }, hasAccess: true
        })
        this.toast.success('User shared successfully');
        this.closeDialog()
      }
    })
  }

}
